import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveMachine: ['machine', 'onSuccess', 'onError'],
  removeMachine: ['machine', 'onSuccess', 'onError'],
  machineError: ['error']
})

const saveMachine = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeMachine = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const machineError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.MACHINE_ERROR]: machineError,

  [Types.SAVE_MACHINE]: saveMachine,
  [Types.REMOVE_MACHINE]: removeMachine,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as MachineTypes,
  Creators as MachineActions
}
